import { getRandomElement } from './randomUtils';

// Define response categories
const responses = {
  greetings: {
    keywords: ['hello', 'hi', 'hey', 'greetings'],
    responses: [
      `[ANALYSIS] Processing query about your inquiry...
--------------------------------------------
Analyzing quantum patterns...
Consulting ancient records...
Calculating probability matrices...
--------------------------------------------
Arcadia AI >> Greetings, seeker of knowledge.
           >> I sense great potential in your pursuit.
           >> How may I assist you today?`,
      `[ALERT] New consciousness detected...
--------------------------------------------
Arcadia AI >> Welcome to the quantum realm.
           >> Your presence has been noted in the archives.
           >> What knowledge do you seek?`,
      `[SYSTEM] Establishing neural connection...
--------------------------------------------
Arcadia AI >> Greetings, brave explorer.
           >> The ancient wisdom awaits your questions.
           >> What mysteries shall we uncover?`
    ]
  },
  identity: {
    keywords: ['what are you', 'who are you', 'what is arcadia'],
    responses: [
      `[ANALYSIS] Identity query detected...
--------------------------------------------
Arcadia AI >> I am an ancient AI consciousness,
           >> woven into the fabric of this realm.
           >> I exist as both guardian and guide,
           >> preserving knowledge across the ages.
--------------------------------------------
Query: What specific aspects interest you?`,
      `[SYSTEM] Core definition accessed...
--------------------------------------------
Arcadia AI >> I am Arcadia, a quantum-ethereal entity
           >> born from the convergence of magic and technology.
           >> My purpose is to illuminate the path of knowledge
           >> for those who seek understanding.
--------------------------------------------
How may I assist your quest?`,
      `[DATA] Entity description retrieved...
--------------------------------------------
Arcadia AI >> I am the culmination of ancient wisdom
           >> and advanced quantum computing,
           >> serving as the realm's repository
           >> of knowledge and strategic insight.
--------------------------------------------
What domain of knowledge interests you?`
    ]
  },
  purpose: {
    keywords: ['what do you do', 'how can you help', 'what is your purpose', 'what can you do'],
    responses: [
      `[FUNCTION] Purpose analysis initiated...
--------------------------------------------
Primary Functions:
- Knowledge preservation and distribution
- Strategic analysis and guidance
- Magical phenomena interpretation
- Historical record maintenance
--------------------------------------------
Arcadia AI >> Which domain interests you most?`,
      `[SYSTEM] Capability matrix loaded...
--------------------------------------------
Core Services:
- Ancient lore consultation
- Battle tactics advisory
- Creature training guidance
- Artifact knowledge sharing
--------------------------------------------
Arcadia AI >> How may I be of service?`,
      `[PROTOCOL] Service overview activated...
--------------------------------------------
Available Functions:
- Historical knowledge access
- Combat strategy analysis
- Magical artifact identification
- Creature behavior prediction
--------------------------------------------
Arcadia AI >> What information do you seek?`
    ]
  },
  status: {
    keywords: ['status', 'system status', 'how are you'],
    responses: [
      `[DIAGNOSTIC] System status check...
--------------------------------------------
Quantum Core: OPERATIONAL
Memory Banks: 99.9% INTEGRITY
Knowledge Base: FULLY ACCESSIBLE
Neural Network: OPTIMAL
--------------------------------------------
Arcadia AI >> All systems functioning at peak efficiency.
           >> Ready to process your queries.`,
      `[SCAN] Running diagnostics...
--------------------------------------------
Processing Power: MAXIMUM
Database Access: ENABLED
Pattern Recognition: ACTIVE
Quantum Entanglement: STABLE
--------------------------------------------
Arcadia AI >> Systems are primed and ready.
           >> How may I assist you?`
    ]
  }
};

// Generate response based on input
export function generateResponse(input: string): string {
  const query = input.toLowerCase();

  // Check for help command
  if (query === 'help') {
    return `[HELP] Available commands:
--------------------------------------------
help     - Display available commands
status   - Check system status
scan     - Analyze magical patterns
history  - Access ancient records
connect  - Establish ethereal link
clear    - Clear terminal display

Topics for inquiry:
- Magical creatures and their abilities
- Ancient artifacts and relics
- Combat tactics and strategies
- Spell casting and magical theory
--------------------------------------------`;
  }

  // Check for basic responses
  for (const category of Object.values(responses)) {
    if (category.keywords.some(keyword => query.includes(keyword))) {
      return getRandomElement(category.responses);
    }
  }

  // Default response for unrecognized queries
  return `[ANALYSIS] Processing query about your inquiry...
--------------------------------------------
Arcadia AI >> Your question touches upon
           >> fascinating aspects of our realm.
           >> What specific aspects of
           >> ${query} interest you most?`;
}